import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User } from './types';

// Keycloak manages the session. The access token is held in memory only
// (Redux state) — no localStorage writes. On page reload, keycloak.init()
// with onLoad:'check-sso' silently re-authenticates via the Keycloak session
// cookie, then App.tsx re-populates the store.
const initialState: AuthState = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isLoading: false,
  isAdmin: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Called after Keycloak authenticates (init or token refresh) to store the
    // current access token in memory for use as Bearer header in API calls.
    setKeycloakToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      state.isAuthenticated = true;
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.isAdmin = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setKeycloakToken, setUser, logout, setLoading, setIsAdmin } = authSlice.actions;

export default authSlice.reducer;
